import { createStyles } from '@mui/styles';

import { Theme } from '../../styles/theme';

const styles = (theme: Theme) =>
  createStyles({
    pageContent: {
      marginRight: 'auto',
      marginLeft: 'auto',
      backgroundColor: theme.palette.grey[50],
      flexDirection: 'column',
      flex: '1 1 100%',
    },
  });

export default styles;
